module.exports = __webpack_public_path__ + "img/erik-arbores1.9eccf88d.jpg";